import type { BibleBook } from './types';

export const BIBLE_BOOKS: BibleBook[] = [
  // Old Testament
  { name: 'Genesis', testament: 'old', chapters: 50 },
  { name: 'Exodus', testament: 'old', chapters: 40 },
  { name: 'Leviticus', testament: 'old', chapters: 27 },
  { name: 'Numbers', testament: 'old', chapters: 36 },
  { name: 'Deuteronomy', testament: 'old', chapters: 34 },
  { name: 'Joshua', testament: 'old', chapters: 24 },
  { name: 'Judges', testament: 'old', chapters: 21 },
  { name: 'Ruth', testament: 'old', chapters: 4 },
  { name: '1 Samuel', testament: 'old', chapters: 31 },
  { name: '2 Samuel', testament: 'old', chapters: 24 },
  { name: '1 Kings', testament: 'old', chapters: 22 },
  { name: '2 Kings', testament: 'old', chapters: 25 },
  { name: '1 Chronicles', testament: 'old', chapters: 29 },
  { name: '2 Chronicles', testament: 'old', chapters: 36 },
  { name: 'Ezra', testament: 'old', chapters: 10 },
  { name: 'Nehemiah', testament: 'old', chapters: 13 },
  { name: 'Esther', testament: 'old', chapters: 10 },
  { name: 'Job', testament: 'old', chapters: 42 },
  { name: 'Psalms', testament: 'old', chapters: 150 },
  { name: 'Proverbs', testament: 'old', chapters: 31 },
  { name: 'Ecclesiastes', testament: 'old', chapters: 12 },
  { name: 'Song of Solomon', testament: 'old', chapters: 8 },
  { name: 'Isaiah', testament: 'old', chapters: 66 },
  { name: 'Jeremiah', testament: 'old', chapters: 52 },
  { name: 'Lamentations', testament: 'old', chapters: 5 },
  { name: 'Ezekiel', testament: 'old', chapters: 48 },
  { name: 'Daniel', testament: 'old', chapters: 12 },
  { name: 'Hosea', testament: 'old', chapters: 14 },
  { name: 'Joel', testament: 'old', chapters: 3 },
  { name: 'Amos', testament: 'old', chapters: 9 },
  { name: 'Obadiah', testament: 'old', chapters: 1 },
  { name: 'Jonah', testament: 'old', chapters: 4 },
  { name: 'Micah', testament: 'old', chapters: 7 },
  { name: 'Nahum', testament: 'old', chapters: 3 },
  { name: 'Habakkuk', testament: 'old', chapters: 3 },
  { name: 'Zephaniah', testament: 'old', chapters: 3 },
  { name: 'Haggai', testament: 'old', chapters: 2 },
  { name: 'Zechariah', testament: 'old', chapters: 14 },
  { name: 'Malachi', testament: 'old', chapters: 4 },
  // New Testament
  { name: 'Matthew', testament: 'new', chapters: 28 },
  { name: 'Mark', testament: 'new', chapters: 16 },
  { name: 'Luke', testament: 'new', chapters: 24 },
  { name: 'John', testament: 'new', chapters: 21 },
  { name: 'Acts', testament: 'new', chapters: 28 },
  { name: 'Romans', testament: 'new', chapters: 16 },
  { name: '1 Corinthians', testament: 'new', chapters: 16 },
  { name: '2 Corinthians', testament: 'new', chapters: 13 },
  { name: 'Galatians', testament: 'new', chapters: 6 },
  { name: 'Ephesians', testament: 'new', chapters: 6 },
  { name: 'Philippians', testament: 'new', chapters: 4 },
  { name: 'Colossians', testament: 'new', chapters: 4 },
  { name: '1 Thessalonians', testament: 'new', chapters: 5 },
  { name: '2 Thessalonians', testament: 'new', chapters: 3 },
  { name: '1 Timothy', testament: 'new', chapters: 6 },
  { name: '2 Timothy', testament: 'new', chapters: 4 },
  { name: 'Titus', testament: 'new', chapters: 3 },
  { name: 'Philemon', testament: 'new', chapters: 1 },
  { name: 'Hebrews', testament: 'new', chapters: 13 },
  { name: 'James', testament: 'new', chapters: 5 },
  { name: '1 Peter', testament: 'new', chapters: 5 },
  { name: '2 Peter', testament: 'new', chapters: 3 },
  { name: '1 John', testament: 'new', chapters: 5 },
  { name: '2 John', testament: 'new', chapters: 1 },
  { name: '3 John', testament: 'new', chapters: 1 },
  { name: 'Jude', testament: 'new', chapters: 1 },
  { name: 'Revelation', testament: 'new', chapters: 22 },
];

export const THEME_COLORS: Record<string, string> = {
  love: '#e74c3c',
  faith: '#3498db',
  hope: '#2ecc71',
  wisdom: '#f1c40f',
  salvation: '#9b59b6',
  prophecy: '#e67e22',
  creation: '#1abc9c',
  judgment: '#c0392b',
  mercy: '#2980b9',
  covenant: '#8e44ad',
  prayer: '#27ae60',
  worship: '#d35400',
};

export const ERA_ORDER = [
  'Creation',
  'Patriarchs',
  'Exodus & Wilderness',
  'Conquest & Judges',
  'United Monarchy',
  'Divided Kingdom',
  'Exile',
  'Return & Restoration',
  'Intertestamental',
  'Life of Christ',
  'Early Church',
];

export const TRANSLATION_OPTIONS = [
  { value: 'kjv', label: 'KJV' },
  { value: 'web', label: 'WEB' },
  { value: 'asv', label: 'ASV' },
];

export const SUGGESTED_QUESTIONS = [
  'What does the Bible say about love?',
  'Who was King David?',
  'What are the Beatitudes?',
  'What happened at the Battle of Jericho?',
  'What is the meaning of the Parable of the Sower?',
  'What does Psalm 23 teach us?',
];
